import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BreadCrumbItem from './BreadCrumbItem';
import { fetchOrderDetails } from '../../../actions';
import { ROUTES } from '../../../constants';
import { formatBreadCrumbsPath } from '../../../utils/format';
import { getIsUserLoggedIn } from '../../../utils/cookie';

type Props = {
  getOrderDetails: Function,
  history: Object,
};

class BreadCrumbs extends Component<Props> {
  onClickLink = () => {
    const { getOrderDetails, history } = this.props;
    const isAuth = getIsUserLoggedIn();
    return isAuth
      ? history.push(ROUTES.PATH.ORDER_HISTORY)
      : getOrderDetails(history);
  };

  render() {
    const { history } = this.props;
    const { pathname } = history.location;
    const pathArray = formatBreadCrumbsPath(pathname);

    return (
      <div
        id="breadcrumb"
        className="breadcrumb"
        data-automation-id="breadcrumb_header"
      >
        <ul id="header-crumb" className="breadcrumb__header">
          {pathArray.map((pathObject: any, index: number) => {
            const { path } = pathObject;
            const pathName = ROUTES.BREADCRUMB[path];
            const pathKey = `${path}-${index}`;

            if (
              pathName === null &&
              (path !== '/order/view' || !getIsUserLoggedIn())
            ) {
              return null;
            }

            const isLastPath = index === pathArray.length - 1;

            return (
              <BreadCrumbItem
                key={pathKey}
                isLastPath={isLastPath}
                pathName={pathName}
                path={path}
                onClickOnlineOrderLink={this.onClickLink}
              />
            );
          })}
        </ul>
      </div>
    );
  }
}

const mapDispatchToProps = {
  getOrderDetails: fetchOrderDetails,
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(BreadCrumbs)
);
